module.exports = __webpack_public_path__ + "static/media/charalambos_antoniades.02bb97b1.png";